export const getInitialRangeStateFromFacet = ({
  min,
  max,
  status,
}: {
  min: number;
  max: number;
  status: { min?: number; max?: number };
}) => {
  if (Object.keys(status).length === 2) {
    const { min: statusMin, max: statusMax } = status;
    if (statusMin < min || statusMax > max) {
      return `${min}-${max}`;
    }
    return `${statusMin}-${statusMax}`;
  }

  return '';
};

export const getInitialRangeState = (str): [number, number] => {
  if (!str || typeof str !== 'string') return null;

  const strArr = str.split('-');

  if (strArr?.length !== 2) return null;

  return [Number(strArr[0]), Number(strArr[1])];
};
